var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        { attrs: { value: _vm.visible, persistent: "", "max-width": "600" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-layout",
                {
                  staticClass: "pr-15 header",
                  attrs: { row: "", "align-center": "" }
                },
                [
                  _c(
                    "v-flex",
                    [
                      _c("v-card-title", { staticClass: "title mb-0 pb-0" }, [
                        _vm._v("Estados da conta")
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", { staticClass: "body-1 pt-1" }, [
                        _vm._v(
                          "Abaixo estão os possíveis estados com sua ordenação."
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", outlined: "", icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-container",
                { staticClass: "pt-2 pb-2" },
                [
                  _c(
                    "v-timeline",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.statuses, function(status, index) {
                      return _c(
                        "v-timeline-item",
                        {
                          key: index,
                          attrs: {
                            color: status.color,
                            icon: status.icon,
                            "fill-dot": ""
                          }
                        },
                        [
                          _c(
                            "v-card",
                            { staticClass: "elevation-2" },
                            [
                              _c(
                                "v-card-title",
                                {
                                  staticClass:
                                    "subheading font-weight-bold text-uppercase mb-0 py-0 pt-10"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(status.order) +
                                      " - " +
                                      _vm._s(status.name) +
                                      "\n                "
                                  ),
                                  status.order <= _vm.orderActive
                                    ? _c(
                                        "v-icon",
                                        { attrs: { color: "green" } },
                                        [_vm._v("check")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-card-text", { staticClass: "py-0 pb-10" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(status.description) +
                                    "\n              "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a190beb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a190beb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Users/Status/Statuses.vue
// module id = null
// module chunks = 